import { Component, Prop, Vue } from 'vue-property-decorator'
import _com from "../../../assets/js/common";

@Component
export default class luckHistoryDialog extends Vue {
    @Prop() private luckHistoryData!: any;
    @Prop() private userPhoneNumber!: any;
    
    get roomData() {//房间数据
        return this.$store.getters["getRoomDetail/getRoomDetail"];
    }

    get luckHistory() {//抽奖信息
        return this.$store.getters["refresh/getLuckHistory"];
    }
    mounted() {
        console.log(JSON.parse(JSON.stringify(this.luckHistoryData)),'luckHist111111oryData');
        console.log(this.roomData);
        console.log(this.userPhoneNumber,'userPhoneNumber');
    }
    viewCoupon() {
        location.href = "//m" + this.domain + "/muser/coupon/list?orderStatus=0";
    }
    close() {
        this.$store.dispatch('refresh/setIsShowPrizeHistoryAsync', false);
    }

}
